import React, { useEffect, useState } from "react";
import AllQuestions from "./QuestionTypes/AllQuestions";
import { useSelector } from "react-redux";
import axios from "../../../axios";
import moment from "moment";
import { Link, NavLink, useLocation } from "react-router-dom";
import { SubjectIcon } from "../../../SubjectIcon";
import UnAuthAssessmentPopup from "./QuestionTypes/UnAuthAssessmentPopup";
import InstructionsPopup from "./QuestionTypes/InstructionsPopup";
import AssessmentNotAllowedPopup from "./QuestionTypes/AssessmentNotAllowedPopup";
import { useNavigate } from "react-router-dom";
import { Tooltip } from "@mui/material";
import { assessmentTimeHelper, assessmentDateHelper } from "../../../utils/datetime_helper";
import { BookText, CalendarDays } from "lucide-react";
import { shortenParagraph } from "../../../utils/Engagement";

export default function PendingAss({ filter }) {
  const [pendingAss, setPendingAss] = useState({
    openAssignment: false,
    assessmentId: null,
  });
  let data = JSON.parse(localStorage.getItem("breathForStudent"));
  const navigate = useNavigate()
  const [pendingCard, setPendingCard] = useState([]);
  const currentUser = useSelector((state) => state.user.currentUser);
  const [isGettingData, setIsGettingData] = useState(true);
  const [todaysData, setTodaysData] = useState([]);
  const [previousData, setPreviousData] = useState([]);
  const today = new Date().toISOString().split("T")[0];
  const [errMsg, setErrMsg] = useState("Something went Wrong!");
  const [unAuthPopup, setUnAuthPopup] = useState(false);
  const [instructionsPopup, setInstructionsPopup] = useState(false);
  const [notAllowedPopup, setNotAllowedPopup] = useState(false);
  const [currentAssessmentId, setCurrentAssessmentId] = useState(null);

  useEffect(() => {

    const pendingBox = async () => {
      try {
        let response = await axios.get(
          `/assessment/filterByStudentId/${currentUser?.id}/pending?_page=${filter?.page}&_limit=${filter?.limit}&sortBy=${filter?.sortBy}` +
          `${filter?.date
            ? `&date=${moment(filter?.date).format("YYYY-MM-DD")}`
            : ``
          }` +
          `${filter?.time ? `&time=${filter?.time}` : ``}` +
          `${filter?.subjectId?.length !== 0
            ? `&subjectId=${filter?.subjectId}`
            : ``
          }`
        );

        response &&
          setTodaysData(
            response.data.data.filter(
              (item) => moment(item.deadline).format("YYYY-MM-DD") === today
            )
          );

        console.log(
          today,
          response.data.data.map((item) =>
            moment(item.deadline).format("YYYY-MM-DD")
          )
        );

        setPreviousData(
          response.data.data.filter(
            (item) => moment(item.deadline).format("YYYY-MM-DD") !== today
          )
        );
        setPendingCard(response.data.data);
        setIsGettingData(false);
      } catch (error) {
        console.log(error);
      }
    };
    pendingBox();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter]);

  // const timeHelper = (date, time) => {
  //   // Parse date string
  //   const dateTime = new Date(date);

  //   // Extract hours and minutes from the time string
  //   const [hours, minutes] = time?.split(":").map(Number);

  //   // Set hours and minutes in the local time zone
  //   dateTime.setUTCHours(hours);
  //   dateTime.setUTCMinutes(minutes);

  //   // Format the output date string
  //   const formattedDate = `${dateTime.getDate().toString().padStart(2, "0")}/${(
  //     dateTime.getMonth() + 1
  //   )
  //     .toString()
  //     .padStart(2, "0")}/${dateTime.getFullYear()} - ${dateTime
  //       .getHours()
  //       .toString()
  //       .padStart(2, "0")}:${dateTime
  //         .getMinutes()
  //         .toString()
  //         .padStart(2, "0")} ${formatTime(dateTime.getHours())}`;

  //   return formattedDate;
  // };
  const timeHelper = (date, time) => {
    // Parse date string
    const dateTime = new Date(date);

    let hours = 0, minutes = 0; // Default values in case time is invalid
    if (time && typeof time === "string" && time.includes(":")) {
      [hours, minutes] = time.split(":").map(Number);
    }

    // Set hours and minutes in the local time zone
    dateTime.setUTCHours(hours);
    dateTime.setUTCMinutes(minutes);

    // Format the output date string
    const formattedDate = `${dateTime.getDate().toString().padStart(2, "0")}/${(
      dateTime.getMonth() + 1
    )
      .toString()
      .padStart(2, "0")}/${dateTime.getFullYear()} - ${dateTime
        .getHours()
        .toString()
        .padStart(2, "0")}:${dateTime
          .getMinutes()
          .toString()
          .padStart(2, "0")} ${formatTime(dateTime.getHours())}`;

    return formattedDate;
  };

  //to append am/pm in time string
  function formatTime(inputTime) {
    var hours = inputTime;
    hours = parseInt(hours);
    if (hours >= 12) {
      return " pm";
    } else {
      return " am";
    }
  }

  const handleQuestionfalse = () => {
    setPendingAss({
      ...pendingAss,
      openAssignment: false,
    });
  };

  const isReadyToOpen = async (assessmentId) => {
    try {
      let res = await axios.get(`/assessment/getForStudent/${assessmentId}`);
      let res2 = await axios.get(
        `/assessment/getStartedFlag/assessmentId/${assessmentId}/studentId/${data.id}`
      );
      if (res && res2) {
        setCurrentAssessmentId(assessmentId);
        if (res2.data.data.started_flag === false) {
          setInstructionsPopup(true);
        } else {
          setNotAllowedPopup(true);
        }
      }
      if (res) {
        return true;
      }
    } catch (error) {
      console.log(error);
      setErrMsg(error.response.data.message);
      setUnAuthPopup(true);
      return false;
    }
  };

  const timeHelperOnlyTime = (time) => {
    const [hours, minutes] = time.split(":").map(Number);
    const formattedTime = `${hours.toString().padStart(2, "0")}:${minutes
      .toString()
      .padStart(2, "0")}`;

    return formattedTime;
  };

  function isExpired(date, scheduleTime, totalDuration) {

    const now = new Date(date);

    if (isNaN(now.getTime())) {
      console.error("Invalid Date:", date);
      return "Error: Invalid Date";
    }

    const currentDate = now.toISOString().split("T")[0];

    // Combine the date with schedule time in 24-hour format
    const fullDateTime = `${currentDate}T${timeHelperOnlyTime(scheduleTime)}:00.000Z`;

    // Create a Date object from the combined string
    const scheduleDate = new Date(fullDateTime);

    // Add total duration (in minutes) to the schedule time
    scheduleDate.setMinutes(scheduleDate.getMinutes() + totalDuration);

    // Compare the adjusted time with the current time
    const currentTime = new Date();
    const adjustedTime = scheduleDate.getTime();

    return adjustedTime <= currentTime ? "Expired" : "Scheduled";
  }

  const styles = {
    expired: {
      color: "red",
      fontWeight: "500",
      fontSize: "13px",
      lineHeight: "18px"
    },
    scheduled: {
      fontWeight: "500",
      fontSize: "13px",
      lineHeight: "18px",
      color: " #666666",
    },
  };

  return (
    <div className="totalPenadingAssContainer">
      <div className="headingOfAss mt-4">Today ({todaysData.length})</div>
      <div className="horizontalLineAss"></div>
      <div className="d-flex gap-4 mt-3 flex-wrap">
        {todaysData &&
          todaysData.length > 0 &&
          todaysData.map((item, index) => (
            // <div
            //   key={index}
            //   className="containerForPendinDeatailAss p-3 "
            //   // onClick={(e) => {
            //   //   setPendingAss({
            //   //     ...PendingAss,
            //   //     openAssignment: true,
            //   //     assessmentId: item?.id,
            //   //   });
            //   // }
            //   // }
            //   onClick={(e) => {
            //     e.preventDefault();
            //     const screenWidth = window.screen.width;
            //     const screenHeight = window.screen.height;
            //     const newWindow = window.open(
            //       `/Assessment/pending/questions/${item?.id}`,
            //       "_blank",
            //       `width=${screenWidth},height=${screenHeight}`
            //     );
            //     newWindow.addEventListener("beforeunload", () => {
            //       window?.location?.reload();
            //     });
            //     setPendingAss({
            //       ...PendingAss,
            //       openAssignment: true,
            //       assessmentId: item?.id,
            //     });
            //   }}
            // >
            //   <div className="kannadaHeaderAss">{item?.subject?.name}</div>
            //   <div className="headingOfAss mt-2">{item?.name}</div>
            //   <span className="deadlineAss">Deadline</span> &nbsp;
            //   <span className="deadlineDateAss">
            //     {timeHelper(item?.deadline)}
            //   </span>
            // </div>
            <div
              key={index}
              // className="summarySubBoxContainerHW"
              className="w-80 h-32 d-flex flex-column py-2 px-3 text-start shadow-sm rounded-4 cursor-pointer card_style"
              style={{
                borderTop: `8px solid #${item?.subject?.subject_color}`
              }}
              onClick={async (e) => {
                e.preventDefault();
                await isReadyToOpen(item?.id);

                setPendingAss({
                  ...PendingAss,
                  openAssignment: true,
                  assessmentId: item?.id,
                });
              }}
            >
              <div
                className="d-flex SubsummarySubBoxContainer justify-content-between align-items-center"
              >
                <div>
                  <div className="subboxSubjectName">{item?.subject?.name}</div>
                </div>
                <div>
                  <img
                    src={`${SubjectIcon?.find(
                      (i) => i.subjectName === item?.subject?.name
                    )?.icon
                      }`}
                    alt=""
                  />
                </div>
              </div>
              <div
                className="SubsummarySubBoxContainer"
                style={{ paddingTop: "0", position: "relative" }}
              >
                <div className="headingOfHW" title={item?.name}>
                  {
                    <Tooltip
                      title={item?.name}
                      arrow
                      placement="bottom"
                      enterDelay={200}
                      leaveDelay={100}
                    >
                      <div className="flex">
                        <BookText size={16} className="me-2 mt-1 text-dark" />
                        {shortenParagraph(item?.name, 25)}
                      </div>
                    </Tooltip>
                  }
                </div>
                <div className="flex mt-2">
                  <CalendarDays size={16} className="me-2 text-dark" />
                  <span className="deadline">Scheduled On</span> &nbsp;
                  <span className="deadlineDate">
                    {/* {timeHelper(item?.deadline, item?.schedule_time)} */}
                    {assessmentDateHelper(item?.schedule_date)}{" - "}
                    {assessmentTimeHelper(item?.schedule_time)}
                  </span>
                </div>
                {/* <NavLink to="/Assessment/adaptivequestion">
                  // 
                </NavLink> */}
                {
                  item.isAdaptive && (
                    <span style={{ padding: "7px 12px", position: "absolute", top: "45px", right: "-10px", borderRadius: "6px" }}
                      onClick={((e) => {
                        e.stopPropagation()
                      })}>
                      <img src="/images/adaptiveImg.png" alt="img" style={{ width: "90px" }} />
                    </span>
                  )
                }
                {
                  item.autoEvalEnabled && (
                    <span style={{ padding: "0px 11px", position: "absolute", top: "45px", right: "0px", borderRadius: "6px" }}
                      onClick={((e) => {
                        e.stopPropagation()
                      })}>
                      <img src="/images/auto-eva.png" alt="img" style={{ width: "60px" }} />
                    </span>
                  )
                }

              </div>
            </div>
          ))}
      </div>

      <div className="headingOfAss mt-4">Others ({previousData.length})</div>
      <div className="horizontalLineAss"></div>
      <div className="d-flex gap-4 mt-3 flex-wrap">
        {previousData &&
          previousData.length > 0 &&
          previousData.map((item, index) => (
            // <div
            //   // <Link className="link" to={`/Assessment/pending/questions/${item?.id}`}>
            //   key={index}
            //   className="containerForPendinDeatailAss p-3 "
            //   onClick={(e) => {
            //     e.preventDefault();
            //     const screenWidth = window.screen.width;
            //     const screenHeight = window.screen.height;
            //     const newWindow = window.open(
            //       `/Assessment/pending/questions/${item?.id}`,
            //       "_blank",
            //       `width=${screenWidth},height=${screenHeight}`
            //     );
            //     newWindow.addEventListener("beforeunload", () => {
            //       window?.location?.reload();
            //     });
            //     setPendingAss({
            //       ...PendingAss,
            //       openAssignment: true,
            //       assessmentId: item?.id,
            //     });
            //   }}
            // >
            //   <div className="kannadaHeaderAss">{item?.subject?.name}</div>
            //   <div className="headingOfAss mt-2">{item?.name}</div>
            //   <span className="deadlineAss">Deadline</span> &nbsp;
            //   <span className="deadlineDateAss">
            //     {timeHelper(item?.deadline)}
            //   </span>
            // </div>
            <div
              key={index}
              // className="summarySubBoxContainerHW"
              className="w-80 h-32 d-flex flex-column py-2 px-3 text-start shadow-sm rounded-4 cursor-pointer card_style"
              style={{
                borderTop: `8px solid #${item?.subject?.subject_color}`
              }}
              onClick={async (e) => {
                e.preventDefault();
                const openAssFlag = await isReadyToOpen(item?.id);
                // if (openAssFlag) {
                //   const screenWidth = window.screen.width;
                //   const screenHeight = window.screen.height;
                //   const newWindow = window.open(
                //     `/Assessment/pending/questions/${item?.id}`,
                //     "_blank",
                //     `width=${screenWidth},height=${screenHeight}`
                //   );
                //   newWindow.addEventListener("beforeunload", () => {
                //     window?.location?.reload();
                //   });
                //   setPendingAss({
                //     ...PendingAss,
                //     openAssignment: true,
                //     assessmentId: item?.id,
                //   });
                // }
              }}
            >
              <div
                className="d-flex SubsummarySubBoxContainer justify-content-between align-items-center"
              >
                <div>
                  <div className="subboxSubjectName">{item?.subject?.name}</div>
                </div>
                <div>
                  <img
                    src={`${SubjectIcon?.find(
                      (i) => i.subjectName === item?.subject?.name
                    )?.icon
                      }`}
                    alt=""
                  />
                </div>
              </div>
              <div
                className="SubsummarySubBoxContainer"
                style={{ paddingTop: "0" }}
              >
                <div className="headingOfHW" title={item?.name}>
                  {
                    <Tooltip
                      title={item?.name}
                      arrow
                      placement="bottom"
                      enterDelay={200}
                      leaveDelay={100}
                    >
                      <div className="flex">
                        <BookText size={16} className="me-2 mt-1 text-dark" />
                        {shortenParagraph(item?.name, 25)}
                      </div>
                    </Tooltip>
                  }
                </div>
                <div className="d-flex mt-2">
                  <CalendarDays size={16} className="me-2 text-dark" />
                  <div
                    className="mr-2"
                    style={
                      isExpired(item?.deadline, item?.schedule_time, item?.total_duration) === "Expired"
                        ? styles.expired
                        : styles.scheduled
                    }
                  >
                    {isExpired(item?.deadline, item?.schedule_time, item?.total_duration)}
                  </div>
                  <span className="deadlineDate">
                    {/* {timeHelper(item?.deadline, item?.schedule_time)} */}
                    {assessmentDateHelper(item?.schedule_date)}{" - "}
                    {assessmentTimeHelper(item?.schedule_time)}
                  </span>
                </div>

              </div>
            </div>
            // </Link>
          ))}
      </div>

      {unAuthPopup && (
        <UnAuthAssessmentPopup
          setUnAuthPopup={setUnAuthPopup}
          errMsg={errMsg}
          closingWindowFlag={false}
        />
      )}

      {console.log("instructionsPopup", instructionsPopup)}
      {instructionsPopup && (
        <InstructionsPopup
          setInstructionsPopup={setInstructionsPopup}
          currentAssessmentId={currentAssessmentId}
        />
      )}
      {console.log("notAllowedPopup", notAllowedPopup)}
      {notAllowedPopup && (
        <AssessmentNotAllowedPopup
          setNotAllowedPopup={setNotAllowedPopup}
          currentAssessmentId={currentAssessmentId}
        />
      )}
      {/* {pendingAss.openAssignment && (
        <AllQuestions
          handleQuestionfalse={handleQuestionfalse}
          assessmentId={pendingAss?.assessmentId}
        />
      )} */}
    </div>
  );
}
